import { type FunctionComponent, useState } from 'react';

import MessageModal from 'components/admin/MessageModal';

import { updateVideoData } from 'services/video';

import dangerButtonTheme from 'themes/Button/admin/danger.scss';

type PropsT = {
  onClose: (removed: boolean) => void;
  videoId: string;
};

// TODO: It is almost the same as <RemovePractitionerModal>,
// we should merge two together.
const RemoveVideoModal: FunctionComponent<PropsT> = ({
  onClose,
  videoId,
}) => {
  const [busy, setBusy] = useState(false);
  return (
    <MessageModal
      busy={busy}
      cancelButtonLabel="No, cancel"
      confirmButtonLabel="Yes, remove"
      confirmButtonTheme={dangerButtonTheme}
      icon="WARN"
      onCancel={() => {
        onClose(false);
      }}
      onConfirm={() => {
        void (async () => {
          try {
            setBusy(true);
            await updateVideoData(videoId, {
              status: 'Deleted',
            });
          } catch (error) {
            // TODO: We need an in-app error modal!
            // eslint-disable-next-line no-alert
            alert('Failed to remove the video');
            throw error;
          } finally {
            setBusy(false);
          }

          onClose(true);
        })();
      }}
    >
      <h1>Are you sure you want to remove this video?</h1>
      <p>This action cannot be undone.</p>
    </MessageModal>
  );
};

export default RemoveVideoModal;
